import { render, staticRenderFns } from "./TipoLeilaoSelect.vue?vue&type=template&id=dd53d70e&"
import script from "./TipoLeilaoSelect.vue?vue&type=script&lang=js&"
export * from "./TipoLeilaoSelect.vue?vue&type=script&lang=js&"
import style0 from "./TipoLeilaoSelect.vue?vue&type=style&index=0&id=dd53d70e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports